import { apiPost } from '~/_shared/utils/api/api.helpers';

export type PdfReportCreateResponse = {
  hash: string;
  message: string;
};

export type PdfReportStatusCode = 'PROCESSED' | 'FAILED';

export type PdfReportStatusResponse = {
  code: PdfReportStatusCode;
  data?: {
    path: string;
  };
};

export const createPdfReport = (mapId: number, settingsOverrides: string[]): Promise<PdfReportCreateResponse> => {
  const requestUrl = `/api/${mapId}/screenshots/pdf-export`;

  return apiPost(requestUrl, {
    settings_override: settingsOverrides,
  });
};

export const getPdfReportStatus = (mapId: number, hash: string): Promise<PdfReportStatusResponse> => {
  const request = {
    hash,
  };
  return apiPost(`/api/${mapId}/screenshots/pdf-status`, request);
};
